export const ScreenReaderSeparator = () => {
  return <span className="sr-only">,</span>;
};
